import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';

export class DeleteOrderRecipeService extends HttpServiceBase {

  handle = (input: DeleteOrderRecipeServiceInput): Promise<Result<DeleteOrderRecipeServiceOutput> | null> => {
    const promise = this.http.delete<Result<DeleteOrderRecipeServiceOutput>>(
      `${this.baseUrlSislogApi}/point-of-sale/order/${input.shopifyOrderId}/recipe/${input.recipeId}?apiKey=${this.getSislogApiKey()}`);
    return promise;
  }
}

export class DeleteOrderRecipeServiceInput {
  shopifyOrderId: number;
  recipeId: number;
}

export class DeleteOrderRecipeServiceOutput {
  result: boolean;
}